export const mimeMap: Record<string, string> = {
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "image/gif": "gif",
    "image/svg+xml": "svg",
    "application/zip": "zip",
    "application/x-zip-compressed": "zip",
    "text/csv": "csv",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.ms-excel": "xls",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
    "text/plain": "txt",
    "application/json": "json",
};

export const getExtensionFromMimeType = (
    contentType: string | undefined,
): string => {
    if (!contentType) {
        return "";
    }

    const pureMime = contentType.split(";")[0].trim().toLowerCase();
    return mimeMap[pureMime] || "";
};
